import { getLangPrefix } from "./langRoutes";

const SITE_ORIGIN = "https://machinepilot.eu";
const HREFLANGS = ["it", "en", "de", "fr", "es", "pl"];
const OG_LOCALES = { it: "it_IT", en: "en_US", de: "de_DE", fr: "fr_FR", es: "es_ES", pl: "pl_PL" };

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const m = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href, hreflang) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/* Canonical + hreflang self-referencing per pagine statiche localizzate
   (privacy, terms, cookies) senza toccare title/description. */
export function applyLocalizedCanonical(path) {
  const prefix = typeof window !== "undefined" ? getLangPrefix(window.location.pathname) : "";
  const lang = prefix.slice(1) || "it";
  document.documentElement.setAttribute("lang", lang);
  setMeta('meta[property="og:locale"]', "content", OG_LOCALES[lang] || "it_IT");
  const hrefFor = (lng) => (lng === "it" ? `${SITE_ORIGIN}${path}` : `${SITE_ORIGIN}/${lng}${path}`);
  setLink("canonical", hrefFor(lang));
  HREFLANGS.forEach((lng) => setLink("alternate", hrefFor(lng), lng));
  setLink("alternate", hrefFor("it"), "x-default");
}


export function applySeoMeta({ title, description, path, ogImage, pathForLang }) {
  // Struttura canonica definitiva: ITALIANO alla root (senza /it/), altre
  // lingue con prefisso /{lang}/ e slug localizzato. Canonical
  // self-referencing per lingua, hreflang reciproco completo,
  // x-default = versione italiana root.
  const prefix = typeof window !== "undefined" ? getLangPrefix(window.location.pathname) : "";
  const lang = prefix.slice(1) || "it";
  const hrefFor = (lng) => {
    const p = pathForLang ? pathForLang(lng) : path;
    return lng === "it" ? `${SITE_ORIGIN}${p}` : `${SITE_ORIGIN}/${lng}${p}`;
  };
  const pageUrl = hrefFor(lang);
  document.title = title;
  document.documentElement.setAttribute("lang", lang);
  setMeta('meta[property="og:locale"]', "content", OG_LOCALES[lang] || "it_IT");
  setMeta('meta[name="description"]', "content", description);
  setMeta('meta[property="og:title"]', "content", title);
  setMeta('meta[property="og:description"]', "content", description);
  setMeta('meta[property="og:url"]', "content", pageUrl);
  setMeta('meta[name="twitter:title"]', "content", title);
  setMeta('meta[name="twitter:description"]', "content", description);
  if (ogImage) {
    setMeta('meta[property="og:image"]', "content", `${SITE_ORIGIN}${ogImage}`);
    setMeta('meta[name="twitter:image"]', "content", `${SITE_ORIGIN}${ogImage}`);
  }
  setLink("canonical", pageUrl);
  HREFLANGS.forEach((lng) => setLink("alternate", hrefFor(lng), lng));
  setLink("alternate", hrefFor("it"), "x-default");
}

export function injectJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd(id) {
  document.getElementById(id)?.remove();
}
